/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    COMMA: ".",
    PLUS: "+",
    MINUS: "-",
    INPUT_BACKSPACE: "<-",
    INPUT_CLEAR: "<<<<<<",
    TOGGLE_SIGN: "ToggleSign"
}
